import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import AuthLayout from "../../Components/Layouts/Authlayout";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { InputType, handleApiErrors, validationRegex } from "../../Utils/Utils";
import CustomTextField from "../../Components/Reusable/CustomTextField";
// import AuthService from "../../Services/AuthService";
import Image from "../../Components/Reusable/Image";
import { OtpVerificationType } from "../../Utils/Enums";
import RoutesPath from "../../Utils/RoutesPath";
import { PngImages, SvgImages } from "../../Utils/LocalImages";
import { SubTitleLabel, TitleLabel } from "../../Components/Reusable/LabelComponents";
import SubmitButtonTwo from "../../Components/Reusable/Buttontwo";
import CustomTextFieldTwo from "../../Components/Reusable/CustomTextFieldTwo";
import StudentDashboardServices from "../../Services/StudentDashboardApiService";
import CoAuthLayout from "../../Components/Layouts/CoAuthlayout";
import CoordinatorApiServices from "../../Services/CoordinatorApiServices";
import SessionManager from "../../Utils/Session";
import { RotatingLines } from "react-loader-spinner";

const CoordinatorLogin = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false)
  const validationSchema = Yup.object().shape({
    email: validationRegex.email,
    password: validationRegex.required
  });

  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = async (data) => {
    setLoading(true);
    const { email, password } = data;
    try {
      const response = await CoordinatorApiServices.coordinatorlogin(email, password);
      SessionManager.shared.deleteStudentToken()
      navigate(RoutesPath.dashboardcoordinator)
    } catch (error) {
      setLoading(false);
      handleApiErrors(error);
    }
  };

  return (
    <CoAuthLayout>
      <div className="col-md-7 m-auto cofocus">
        <div className="d-flex justify-content-center login_logo">
          {/* <Image src={PngImages.logo} alt="Logo" /> */}
          <Image src={SvgImages.logo} className="img-fluid" style={{ height: "70px" }} />
        </div>

        <div className="mb-4 text-center">
          <TitleLabel text={"Welcome Back!"} />
          <SubTitleLabel text={"Enter your Credentials to access your account"} />
        </div>

        <form className="position-relative" onSubmit={handleSubmit(onSubmit)} >
          <CustomTextFieldTwo
            labelTitle="Email Id"
            additionalClasses="profile_input"
            icon={SvgImages.email}
            id="email"
            name="email"
            placeholder="Enter your email id"
            showError={errors?.email}
            errorMessage={errors?.email?.message}
            register={register}
          />

          <CustomTextFieldTwo
            labelTitle="Password"
            additionalClasses="profile_input"
            icon={SvgImages.lock}
            id="password"
            name="password"
            inputType={InputType.password}
            placeholder="Enter your password"
            showError={errors?.password}
            errorMessage={errors?.password?.message}
            register={register}
            imageClass="input-lock-icon"
          />

          <Link to={RoutesPath.coforgotPassword}>
            <h4 className="forgotco mb-4 right_menu_toggle">Forgot password?</h4>
          </Link>

          {loading ? (
            <div className="text-center d-flex justify-content-center">
              <RotatingLines
                height="25"
                width="25"
                strokeColor="#14489F"
                ariaLabel="bars-loading"
                wrapperStyle={{}}
                wrapperClass=""
              />
            </div>
          ) : (
            <SubmitButtonTwo title={"Login"} className='w-100 fw-700 cologinbtn' />

          )}
          <div className="text-center mt-4">
            <h4 className="small-medium-text fw-600 black mb-0" >Don’t have an account?  <Link to={RoutesPath.joinAsCoordinator}>
              <span className="blue cursor-pointer">Register</span></Link>
            </h4>

          </div>

        </form>
      </div>
    </CoAuthLayout>
  );
};

export default CoordinatorLogin;

